var _rect, _circle, _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#f3f4f6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 60,
    r: 25,
    fill: "#d1d5db"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 125 Q35 95 75 95 Q115 95 115 125 L35 125 Z",
    fill: "#d1d5db"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 140,
    textAnchor: "middle",
    fill: "#6b7280",
    fontFamily: "Arial, sans-serif",
    fontSize: 12
  }, "Profile")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholder);
export default __webpack_public_path__ + "static/media/profile-placeholder.dca33af56ab5e05a475e834a922ce753.svg";
export { ForwardRef as ReactComponent };